<template>
  <div
    ref="parallaxWrapper"
    :class="{
      'parallax-wrapper flex h-full w-full': true,
    }"
  >
    <Background
      :theme="theme?.background"
      :class="{
        'flex h-full w-full justify-center': true,
      }"
    >
      <CompactPadding
        :padding="theme?.padding"
        :class="{
          'flex-grow': true,
        }"
      >
        <slot />
      </CompactPadding>
    </Background>
  </div>
</template>

<script setup lang="ts">
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import type { ParallaxTheme } from '~/sanity/types';
import { applyAnimation } from './Animation';
import Background from '~/components/Atoms/Background/Background.vue';
import CompactPadding from '~/components/Atoms/CompactPadding/CompactPadding.vue';

const props = defineProps<{ theme?: ParallaxTheme }>();
const parallaxWrapper = ref<HTMLElement | null>(null);
// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

onMounted(() => {
  applyAnimation(props.theme?.animation, parallaxWrapper); // Apply the animation when the component is mounted
});
</script>

<style lang="scss" scoped></style>
